import { Comment } from './types';

export const MOCK_COMMENTS: Comment[] = [
  {
    id: 1,
    content:
      "「 我強烈推薦 NEX Work 這個求職內推平台！平台內的成員熱心且高效，幾乎都能在 3 天內 完成內推，讓求職過程更加順利。在他們的幫助下，我成功獲得了面試機會。」\n\n這個平台不僅匯聚台灣的優秀人才，更展現了團結互助的精神，為求職者提供了強大的支持！",
    author: "- Becky Chao",
  },
  {
    id: 2,
    content:
      "「很感謝 Nex Work 這樣的平台讓我有機會接觸到專業領域上的前輩，也謝謝所有願意花時間內推我的人，希望有天也能回到這裡成為一位 Giver，繼續茁壯臺灣人的社群。」",
    author: "- 景隆",
  },
  {
    id: 3,
    content:
      "「在美國的留學生找工作都很艱難，很感謝Nex Work提供平台讓台灣的學生能得到更多的內推機會！我在網站上真的得到了大公司內推的幫助，並且拿到面試機會，真的很感謝這個網站，也推薦大家也多多利用這個網站！」",
    author: "- Alvin",
  },
];
